import React from 'react';
import Avatar from '@mui/material/Avatar';

const CustomAvatar = ({ src, alt, title , sx }) => {
  return (<Avatar sx={sx||{}} src={src} alt={alt} title={title}/>);
};

export default CustomAvatar;
